import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-form-input-text-area',
  standalone: false,
  templateUrl: './form-input-text-area.component.html',
  styleUrl: './form-input-text-area.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputTextAreaComponent),
      multi: true
    }
  ]
})
export class FormInputTextAreaComponent implements OnInit, ControlValueAccessor {
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;
  @Input() noLabel: boolean;
  @Input() placeholder: string;
  @Input() readonly: boolean;
  @Input() rows: number = 5;

  public id: string;
  
  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  // value accessor functions
  writeValue(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange($event?.target['value']);
  }
}
